import type { ColorSystemOptions } from "@mui/material/styles";

export const darkEffects: ColorSystemOptions["appEffects"] = {
  glass: {
    blurMd: "16px",
    blurSm: "8px",
    blurXs: "4px",
    radiusMd: "12px",
    radiusSm: "8px",
    saturateMd: "160%",
    saturateSm: "145%",
    saturateXs: "80%",
    transitionSurface: "all 0.2s ease"
  },

  opacity: {
    disabled: 0.8,
    softBorder: 0.16,
    strongBorder: 0.32
  },

  shadow: {
    avatar:
      "0 2px 4px rgba(0, 0, 0, 0.5), 0 4px 8px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.35)",
    card: "0 5px 4px rgba(0, 0, 0, 0.1)",
    depth:
      "linear-gradient(\n" +
      "  to bottom,\n" +
      "  rgba(255, 255, 255, 0.10),\n" +
      "  rgba(255, 255, 255, 0.03),\n" +
      "  rgba(255, 255, 255, 0.00)\n" +
      ")",
    insetMd: "inset 3px 3px 33px -6px rgba(255, 255, 255, 0.08)",
    insetSm: "inset 3px 3px 33px -20px #474F5B",

    lg: "0px 2px 2px -1px rgba(0, 0, 0, 0.4), 0px 4px 6px -2px rgba(0, 0, 0, 0.5), 0px 12px 16px -4px rgba(0, 0, 0, 0.6)", //Profile modal / drawer-like depth OR BaseTooltip stack
    md: "0px 10px 10px rgba(0, 0, 0, 0.5)", //TargetCard.tsx, LocalContentCard.tsx, GlassCard.tsx
    pill: "0 2px 4px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3)",
    sm: "0 2px 4px rgba(0, 0, 0, 0.4)", // EmployeeTimeline.tsx, WhiteGrid.tsx, GlassCard.tsx
    xs: "0 1px 2px rgba(0, 0, 0, 0.3)" //Cells.tsx, SocialSpendDataGrid.tsx, DropDownButtonGridCell.tsx
  }
};
